import useAuth from "hooks/useAuth";

const useUser = () => {
  const { data } = useAuth();

  return data.user;
};

export default useUser;
